import { render, staticRenderFns } from "./MeusCartoes.vue?vue&type=template&id=897f6d62&scoped=true"
import script from "./MeusCartoes.vue?vue&type=script&lang=js"
export * from "./MeusCartoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897f6d62",
  null
  
)

export default component.exports